import { css } from 'styled-components';

const variables = css`
  :root {
    --bg-main: #efefeb;
    --bg-soft: #e7e7e2;
    --bg-card: rgba(255, 255, 255, 0.55);
    --text-primary: #111111;
    --text-secondary: #3a3a3a;
    --text-muted: #6e6e6e;
    --border-light: rgba(20, 20, 20, 0.08);
    --border-medium: rgba(20, 20, 20, 0.14);
    --sydneyblue: #5f6b73;
    --black: #000000;
    --dark-navy: #efefeb;
    --navy: #efefeb;
    --light-navy: #e7e7e2;
    --lightest-navy: #ffffff;
    --navy-shadow: rgba(0, 0, 0, 0.05);
    --dark-slate: #6e6e6e;
    --slate: #3a3a3a;
    --light-slate: #6e6e6e;
    --lightest-slate: #111111;
    --white: #ffffff;
    --green: #5f6b73;
    --green-tint: rgba(95, 107, 115, 0.08);
    --pink: #888888;
    --blue: #5f6b73;
    --beige: #efefeb;
    --darkgrey: #2e2e2e;
    --night: #111111;
    --lightgrey: #efefeb;
    --font-sans: 'Inter', -apple-system, system-ui, sans-serif;
    --font-mono: 'SF Mono', 'Fira Code', monospace;
    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 14px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 22px;
    --fz-heading: 32px;

    --border-radius: 6px;
    --nav-height: 90px;
    --nav-scroll-height: 65px;

    --tab-height: 42px;
    --tab-width: 120px;
    --easing: cubic-bezier(0.4, 0, 0.2, 1);
    --transition: all 0.2s ease;
    --hamburger-width: 30px;
    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s ease;
    --ham-after-active: bottom 0.1s ease-out, transform 0.22s ease 0.12s;
  }
`;

export default variables;